import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DownloadAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", d: "m12 16-.354.354.354.353.354-.353zm.5-12a.5.5 0 0 0-1 0zm-6.854 6.354 6 6 .708-.708-6-6zm6.708 6 6-6-.708-.708-6 6zM12.5 16V4h-1v12z" }), _jsx("path", { stroke: "currentColor", d: "M5 21h14" })] }) });
}
const DownloadAltLight = forwardRef(_DownloadAltLight);
export { DownloadAltLight };
